import { useContext, useEffect, useState } from 'react'

import { AuthenticationContext } from '../../providers/auth-provider'

// Open state for the location select modal, which opens automatically until a folder is selected
const useLocationSelectModal = (selectedFolderId: number | null | undefined, shouldAutoOpen: boolean) => {
  const { ownUser } = useContext(AuthenticationContext)
  const [showLocationSelectModal, setShowLocationSelectModal] = useState<boolean>(false)

  useEffect(() => {
    if (ownUser && shouldAutoOpen && !selectedFolderId) {
      setShowLocationSelectModal(true)
    }
  }, [ownUser, shouldAutoOpen, selectedFolderId])

  return [showLocationSelectModal, setShowLocationSelectModal] as const
}

export default useLocationSelectModal
